<script>
	import { onMount } from 'svelte';
	import List from './List.svelte';
	import Section from './Section.svelte';
	import Badge from './Badge.svelte';

	export let name;
	let page;

	let lists = {
		spenden: [],
		sources: {
			live: [],
			reddit: []
		}
	}

	var item = {
		icon: 'ri-hand-coin-fill',
		title: 'Save Life',
		description: 'This NGO crowdfunds non-lethal military equipment, such as thermal vision scopes & supplies it to the Donbas front lines. It also provides training for Ukrainian soldiers, as well as researching troops’ needs and social reintegration of veterans.',
		flag: false,
		tags: ['civil','sources'],
		url: false
	}
	lists.spenden.push( item )


	lists.sources.live.push( {
		title: "Twitter Live-Thread",
		url: 'https://twitter.com/search?q=Ukrainian&src=trend_click&f=live&vertical=trends'
	} )

	lists.sources.live.push( {
		title: "SPIEGEL.DE Live-Beitrag",
		url: 'https://www.spiegel.de/ausland/russland-ukraine-news-am-montag-kiew-und-moskau-wollen-offenbar-am-montagmorgen-verhandeln-a-06ef9b2e-ef22-46b6-aef1-984c6e2b401b'
	} )

	lists.sources.live.push( {
		title: "BBC Live-Beitrag",
		url: '#'
	} )

	lists.sources.reddit.push( {
		title: "reddit worldnews",
		url: ''
	} )

	lists.sources.reddit.push( {
		title: "reddit UkraineConflict",
		url: ''
	} )


	console.log(lists)
</script>

<main>

<div class="row">
	<div class="col-md-5">

		<div class="sticky-top">


		<ul class="list-group list-group-flush">
		  <li class="list-group-item">
				<h3><span class="badge bg-primary rounded-pill"> <i class="ri-hand-coin-fill"></i></span> spenden</h3>

					<ul class="list-group list-group-flush">
						<li class="list-group-item" data-section="sources.live"><a class="text-primary" href="#donate">an nicht-militäre Organisationen vor Ort spenden</a></li>
						<li class="list-group-item"><a class="text-primary" href="#donate">freien Journalismus vor Ort unterstützen</a></li>
					</ul>
			</li>

			<li class="list-group-item">
				<h3><span class="badge bg-primary rounded-pill"> <i class="ri-hand-coin-fill"></i></span> informiert sein</h3>

					<ul class="list-group list-group-flush">
						<li class="list-group-item" data-section="sources.live"><a class="text-primary" href="#sources.live">wichtige Live-Threads zum Thema</a></li>
						<li class="list-group-item" data-section="sources.video"><a class="text-primary" href="#sources.video">aktuelle Meldungen & Videos <Badge>englisch</Badge></a></li>
						<li class="list-group-item" data-section="sources.reddit"><a class="text-primary" href="#sources.reddit">Hintergründe & Analyse</a></li>

					</ul>
			</li>

		</ul>



		</div>

	</div>
	<div class="col-md-7">


		<Section id="spenden" items={lists.spenden}>

		</Section>

		<Section id="sources.live" items={lists.sources.live} type="button" horizontal2/>
		<div class="row">
			<div class="col-12">

			</div>
			<div class="col-12">
				<Section id="sources.video" feed='https://www.reddit.com/r/UkrainianConflict/search.json?q=url%3Av.redd.it+OR+url%3Ayoutube.com&restrict_sr=on&include_over_18=on&sort=new&t=day&limit=5'>
				<h4>aktuell</h4>

				<div class="ratio ratio-16x9 sticky-bottom">
				  <iframe width="560" height="315" src="https://www.youtube.com/embed/iZMTed_lAEA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
				</div>
				<Section id="sources.news" feed='https://www.reddit.com/r/UkrainianConflict/top.json?restrict_sr=on&include_over_18=on&sort=new&t=day&limit=5'>

				</Section>
				</Section>
			</div>

			</div>



			<Section id="sources.reddit" items={lists.sources.reddit} horizontal/>

	</div>

</div>





</main>

<!-- CSS only -->
<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-1BmE4kWBq78iYhFldvKuhfTAU6auU8tT94WrHftjDbrCEXSU1oBoqyl2QvZ6jIW3" crossorigin="anonymous">

<style>

	.list-group-item {
		border: none; padding: 1rem;
	}

	a { text-decoration: none; }
	main {

		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	header {
		text-align: center;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	.large {
		font-size: 3em;
	}

	.btn {
		text-align: left;
	}

	a.text-primary {
		text-decoration: none; border-bottom: 2px solid #0d6efd; padding-bottom: 10px;
	}
	a:visited {
		color: inherit;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>

<link href="https://cdn.jsdelivr.net/npm/remixicon@2.5.0/fonts/remixicon.css" rel="stylesheet">
